export default __webpack_public_path__ + "static/media/gold-medal.f995559a.svg";